import UshkHeader from './Header'
import UshkFooter from './Footer'
import Icon from './Icon'
import ChartGroup from './ChartGroup'
import Star from './Star'
import Backtop from './Backtop'
import Rate from './Rate'
import Declatration from './Declatration'
import Ad from './Ad'
import Contract from './Contact'
import UshkDatePicker from './DatePicker'

const components = {
  UshkHeader,
  UshkFooter,
  Icon,
  ChartGroup,
  Star,
  Backtop,
  Rate,
  Declatration,
  UshkDatePicker,
  Ad,
  Contract
}

export default function install (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })
}



// WEBPACK FOOTER //
// ./src/components/index.js